//PRODUCTS
export const GET_PRODUCTS = "GET_PRODUCTS"
export const GET_MOBILES = "GET_MOBILES"
export const FILTERD_PRODUCTS = "FILTERD_PRODUCTS"
export const GET_ONE_PRODUCTS = "GET_ONE_PRODUCTS"
export const SET_FILTER = "SET_FILTER"
export const UPDATE_PROFILE_DATA = "UPDATE_PROFILE_DATA"
export const ADD_ADDRESS = "ADD_ADDRESS"
export const GET_ALL_ADDRESS = "GET_ALL_ADDRESS"
export const UPDATE_ADDRESS = "UPDATE_ADDRESS"
export const GET_CUSTOMER = "GET_CUSTOMER"
export const UPDATE_PASSWORD = "UPDATE_PASSWORD"
export const DELETE_ADDRESS = "DELETE_ADDRESS"
export const FORGOT_PASSWORD = "FORGOT_PASSWORD"
export const RESET_PASSWORD = "RESET_PASSWORD"
export const SINGLE_USER = "SINGLE_USER"

// BANNER
export const GET_BANNER = "GET_BANNER"
export const GET_SLIDER_BANNER = "GET_SLIDER_BANNER"
export const GET_TESTIOMONIAL_BANNER = "GET_TESTIOMONIAL_BANNER"

//FAQ
export const GET_FAQ = "GET_FAQ"

//CART
export const GET_CART = "GET_CART"
export const ADD_CART = "ADD_CART"
export const DELETE_CART = "DELETE_CART"
export const CLEAR_CART = "CLEAR_CART";

//COUNTRY
export const GET_COUNTRIES = "GET_COUNTRIES"

//STATES
export const GET_STATES = "GET_STATES"

//CITIES
export const GET_CITIES = "GET_CITIES"

//COUPONS
export const GET_COUPONS = "GET_COUPONS"

//SETTINGS
export const GET_SETTINGS = "GET_SETTINGS"

//BRANDS
export const GET_BRANDS = "GET_BRANDS"

//MODELS
export const GET_MODELS = "GET_MODELS"

//ORDERS
export const GET_ORDERS = "GET_ORDERS"
export const ADD_ORDERS = "ADD_ORDERS"

//PAYMENT
export const CREATE_ORDER = "CREATE_ORDER"

//BRANCH
export const BRANCH = "BRANCH"
